import Attendance, { AttendanceInput } from 'src/models/Attendance';
import DateOnly from 'src/models/common/DateOnly';
import api from './api';
import defaultErrorConverter from './errorHandling/defaultErrorConverter';

interface AttendanceRefParameters {
  classId: number;
  studentUserId: number;
}

export interface SaveAttendanceParameters extends AttendanceRefParameters {
  entries: AttendanceInput[];
}

export interface ApproveAttendanceParameters extends AttendanceRefParameters {
  attendanceId: number;
}

export async function fetchAttendance({ classId, studentUserId }: AttendanceRefParameters): Promise<Attendance[]> {
  try {
    const res = await api.get(`api/classes/${classId}/students/${studentUserId}/attendance`);
    const entries = res.data.data as Attendance[];
    return entries.map(parseAttendance);
  } catch (error) {
    throw defaultErrorConverter(error);
  }
}

export async function saveAttendance({ classId, studentUserId, entries }: SaveAttendanceParameters): Promise<Attendance[]> {
  try {
    const res = await api.put(`api/classes/${classId}/students/${studentUserId}/attendance`, { data: entries });
    const saved = res.data.data as Attendance[];
    return saved.map(parseAttendance);
  } catch (error) {
    throw defaultErrorConverter(error);
  }
}

export async function approveAttendance({ classId, studentUserId, attendanceId }: ApproveAttendanceParameters): Promise<void> {
  try {
    await api.post(`api/classes/${classId}/students/${studentUserId}/attendance/${attendanceId}/approve`);
  } catch (error) {
    throw defaultErrorConverter(error);
  }
}

export async function unapproveAttendance({ classId, studentUserId, attendanceId }: ApproveAttendanceParameters): Promise<void> {
  try {
    await api.delete(`api/classes/${classId}/students/${studentUserId}/attendance/${attendanceId}/approve`);
  } catch (error) {
    throw defaultErrorConverter(error);
  }
}

function parseAttendance(entry: Attendance): Attendance {
  return { ...entry, date: new DateOnly(entry.date) };
}
